import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">CableBiz</h3>
            <p className="footer-description">
              Online billing software for cable TV operators and customers. 
              Effortless payment management with stronger ticketing system.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About US</Link></li>
              <li><Link to="/services">Cable TV</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact">
              <p><strong>General:</strong> info@nldsoft.com</p>
              <p><strong>Tech Support:</strong> support@nldsoft.com</p>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Address</h4>
            <div className="footer-address">
              <p>
                <strong>Registered Office / Operational Office:</strong><br />
                Plot No: 52, Bapujinagar,<br />
                Bhubaneswar, Odisha,<br />
                India - 751009
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2024 Neeladri Software Solutions Pvt Ltd Private Limited. All Rights Reserved. | 
            Cablebiz is a Trademark owned and operated by Neeladri Software Solutions Pvt Ltd Private Limited
          </p>
          <div className="footer-legal">
            <Link to="/terms">Terms & Conditions</Link>
            <span>|</span>
            <Link to="/privacypolicy">Privacy Policy</Link>
            <span>|</span>
            <Link to="/terms-of-use">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

